import React, {Fragment, useState, useEffect, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import Droppable from './droppable.js'
import StitchImage from './stitcher.js'
const styles = {
        container: {
            height: '80vh'
        }
};


    const getImageDimensions = (file, crop) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = function (e) {
                const img = new Image();

                img.onload = function () {
                    const width = this.width- (crop?.left ?? 0) - (crop?.right ?? 0);
                    const height = this.height - (crop?.top ?? 0) - (crop?.bottom ?? 0) ;
                    console.log('>', this.height, height, crop)
                    resolve({ width, height });
                };

                img.src = e.target.result;
            };

            reader.onerror = function (error) {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    }

const Editor = ({selectedPattern, selectedImages, movie}) => {
    const [dimensions, setDimensions] = useState({})
    const [height, setHeight] = useState(0)
    const [chunks, setChunks] = useState([])
    const [showStitch, setShowStitch] = useState(false)

    const handleShowStich = () => {
        setShowStitch(true)
    }
    const ref = useRef(null)
    useEffect(()=>{
        const getDimensions = async() => {
            const _dim = await getImageDimensions(selectedImages[0], movie.crop)
            setDimensions(_dim)
        }
        setHeight(ref.current.clientHeight)
        getDimensions()
        let drops = []
        for (let i = 0; i < selectedPattern; i += 1) {
            drops.push({file: undefined, isSplit: false})
            //drops.push( <Droppable key={`drop-${i}`} selectedImages={selectedImages} dimensions={dimensions} height={height} selectedPattern={selectedPattern} index={i}/>)
        }
        setChunks(drops)
    }, [])
    
    return (
        <Fragment>
            {!showStitch && (<Box sx={styles.container} ref={ref}>
                {chunks.map((chunk, i) => <Droppable key={`drop-${i}`} selectedImages={selectedImages} chunks={chunks} setChunks={setChunks} dimensions={dimensions} height={height} selectedPattern={selectedPattern} index={i} movie={movie}/>)} 
            <Button onClick={handleShowStich} variant="outlined">Stitch</Button>
            </Box>)}
            {showStitch && (<StitchImage
                    chunks={chunks}
                    dimensions={dimensions}
                    height={height}
                    pattern={selectedPattern}
                    movie={movie}
                />)}
        </Fragment>
    );
}


export default Editor;
